import { FunctionComponent, KeyboardEvent, useCallback, useContext } from 'react';
import styles from './styles.module.scss';
import MagnifyingGlassRegularIcon from '../../Icons/MagnifyingGlassRegularIcon';
import { CourseSearchContext } from '../CourseSearchContext';

export const SearchBar: FunctionComponent = () => {
    const { searchTerm, setSearchTerm } = useContext(CourseSearchContext);

    const onSearchKeyUp = useCallback((event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            event.currentTarget.blur();
        }
    }, []);

    return (
        <>
            <div className={styles.searchSection}>
                <div className={styles.searchInputContainer}>
                    <MagnifyingGlassRegularIcon />
                    <input
                        aria-label={`Search courses`}
                        type="text"
                        value={searchTerm}
                        onKeyUp={onSearchKeyUp}
                        onChange={(event) => setSearchTerm(event.target.value)}
                    />
                </div>
            </div>
        </>
    );
};
